import React, { type ComponentType } from 'react';
import '@atlaskit/css-reset';
import PageAppInitialisationAnalytics from '@atlassian/jira-common-analytics-page-app-initialisation/src/index.tsx';
import { FavoriteChangeConsumer } from '@atlassian/jira-favourite-change-provider/src/view/FavoriteChangeConsumer.tsx';
import QueryParamAdapter from '@atlassian/jira-filters-query-param-adapter/src/index.tsx';
import { withSuspense } from '@atlassian/jira-platform-resources-utils/src/utils/with-suspense/index.tsx';
import { filtersDirectoryResource } from '@atlassian/jira-router-resources-directories-filters/src/index.tsx';
import SpaErrorBoundary from '@atlassian/jira-spa-apps-common/src/error-boundary/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { withRouter, type RouteContext, useResource } from '@atlassian/react-resource-router';
import Filters from './view/index.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type Props = RouteContext;

// eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
const useFiltersDirectoryResource = withSuspense(() => useResource(filtersDirectoryResource));

export const FiltersDirectory = ({ location }: Props): React.JSX.Element => {
	const state = useFiltersDirectoryResource();
	const tenantContext = useTenantContext();

	return (
		<QueryParamAdapter location={location}>
			{({ query, onQueryChanged }) => (
				<FavoriteChangeConsumer>
					{(favoriteChangeContext) => (
						<UFOSegment name="filters-directory">
							<Filters
								tenantContext={tenantContext}
								prefetchResult={{ ...state }}
								favoriteChangeContext={favoriteChangeContext}
								query={query}
								onQueryChanged={onQueryChanged}
							/>
						</UFOSegment>
					)}
				</FavoriteChangeConsumer>
			)}
		</QueryParamAdapter>
	);
};

// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RouterWrapper: ComponentType<Record<any, any>> = withRouter(FiltersDirectory);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FiltersDirectoryType = (props: Record<any, any>): React.JSX.Element => (
	<>
		<MarkProductStart />
		<SpaErrorBoundary id="spa-app-bootstrap.directories.filters">
			<PageAppInitialisationAnalytics
				appNameSuffixForV2Event="directory.filters"
				appNameForV3OperationalEvent="filtersDirectory"
			/>
			<RouterWrapper {...props} />
		</SpaErrorBoundary>
	</>
);

export default FiltersDirectoryType;
